/* コレクション一覧 ボトムシート
   - 商品タップ→下からシート（ページ遷移しない）
   - カート追加＝/cart/add.js（本物のカート・シートは閉じない）
   - 今すぐ購入→お届け先入力→Shopify正規チェックアウトへ橋渡し（前入力：best-effort）
   - a11y：フォーカストラップ / ESC / 背面ロック / 閉じたら元カードへフォーカス復帰
   - prefers-reduced-motion はCSS側で停止
*/
(function () {
  var dataEl = document.getElementById('pl-bs-data');
  var sheet = document.getElementById('plBs');
  if (!dataEl || !sheet) return;

  var PRODUCTS = {};
  try {
    JSON.parse(dataEl.textContent).forEach(function (p) { PRODUCTS[p.id] = p; });
  } catch (e) { return; }

  var backdrop = document.getElementById('plBsBackdrop');
  var step1 = document.getElementById('plBsStep1');
  var step2 = document.getElementById('plBsStep2');
  var toastEl = document.getElementById('plBsToast');
  var $ = function (id) { return document.getElementById(id); };

  var CART_SVG = '<svg class="pl-bs__cartic" width="17" height="16" viewBox="0 0 21 20" fill="currentColor" aria-hidden="true"><path d="M20.8729 0.358374C20.766 0.0737247 20.4499 -0.0709586 20.1652 0.0344088L16.2824 1.48282C16.1031 1.54887 15.971 1.70456 15.9348 1.89328L13.7425 13.089H2.85037L1.21953 4.83885H12.6291C12.9326 4.83885 13.1795 4.59194 13.1795 4.28842C13.1795 3.9849 12.9326 3.738 12.6291 3.738H0.54958C0.384452 3.738 0.228758 3.81191 0.124963 3.93929C0.0211686 4.06668 -0.0212898 4.23338 0.0101631 4.39536L1.8596 13.7463C1.90992 14.0042 2.13638 14.1898 2.39902 14.1898H14.1955C14.4581 14.1898 14.6845 14.0027 14.7349 13.7448L16.9554 2.40753L20.5505 1.06764C20.8352 0.960697 20.9799 0.644595 20.8745 0.359946L20.8729 0.358374Z"/><path d="M3.09034 14.7828C1.8967 14.7828 0.924805 15.7547 0.924805 16.9484C0.924805 18.142 1.8967 19.1139 3.09034 19.1139C4.28399 19.1139 5.25588 18.142 5.25588 16.9484C5.25588 15.7547 4.28399 14.7828 3.09034 14.7828ZM3.09034 18.0146C2.50375 18.0146 2.02566 17.5365 2.02566 16.9499C2.02566 16.3633 2.50375 15.8853 3.09034 15.8853C3.67694 15.8853 4.15502 16.3633 4.15502 16.9499C4.15502 17.5365 3.67694 18.0146 3.09034 18.0146Z"/><path d="M13.4146 14.7828C12.2209 14.7828 11.249 15.7547 11.249 16.9484C11.249 18.142 12.2209 19.1139 13.4146 19.1139C14.6082 19.1139 15.5801 18.142 15.5801 16.9484C15.5801 15.7547 14.6082 14.7828 13.4146 14.7828ZM13.4146 18.0146C12.828 18.0146 12.3499 17.5365 12.3499 16.9499C12.3499 16.3633 12.828 15.8853 13.4146 15.8853C14.0012 15.8853 14.4792 16.3633 14.4792 16.9499C14.4792 17.5365 14.0012 18.0146 13.4146 18.0146Z"/></svg>';
  var ADD_LABEL = CART_SVG + '<span>カートに追加</span>';
  var current = null;   // 現在シートに表示中の商品
  var lastFocus = null; // シートを開いたカード（閉じたら戻す）

  // シート類を<body>直下へ移動して position:fixed を必ず“画面基準”にする。
  // （囲い要素にtransform/animationがあると fixed が“その要素基準”になり、ページ最下部から出てしまうため）
  [backdrop, sheet, toastEl, document.getElementById('plBsViewer'), document.getElementById('plBsConfirm')].forEach(function (el) {
    if (el && el.parentNode !== document.body) document.body.appendChild(el);
  });
  // 背面スクロールのロック（このテーマは html がスクロール要素なので html+body 両方止める）
  function lockScroll() { document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }

  function qty() { return parseInt($('plBsQn').textContent, 10) || 1; }
  function setQty(n) { $('plBsQn').textContent = Math.max(1, n); }

  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('show'); }, 1700);
  }

  /* セットの点数。タイトルの「◯点」表記を優先（内容検出は漏れることがあるため） */
  function setSize(p) {
    if (!p) return 99;
    var m = (p.title || '').match(/(\d+)\s*点/);
    if (m) return parseInt(m[1], 10);
    return (p.contents && p.contents.length) ? p.contents.length : 99;
  }

  function priceHTML(p) {
    return p.onSale
      ? '<span class="now sale">' + p.priceF + '</span><span class="was">' + p.cmpF + '</span>'
      : '<span class="now">' + p.priceF + '</span>';
  }

  // ---- 画像ギャラリー（スライド＋ドット。タップで全画面） ----
  function buildGallery(p) {
    var track = $('plBsGTrack'), dots = $('plBsGDots');
    var imgs = (p.imgs && p.imgs.length ? p.imgs : (p.img ? [p.img] : []));
    track.innerHTML = ''; dots.innerHTML = '';
    imgs.forEach(function (u, i) {
      var s = document.createElement('div');
      s.className = 'pl-bs__gslide';
      s.innerHTML = '<img src="' + u + '" alt="' + (p.title || '') + ' 画像' + (i + 1) + '" loading="lazy">';
      s.addEventListener('click', function () { openViewer(imgs, i); });
      track.appendChild(s);
      var d = document.createElement('span');
      d.className = 'pl-bs__gdot' + (i === 0 ? ' on' : '');
      dots.appendChild(d);
    });
    dots.hidden = imgs.length < 2;
    track.scrollLeft = 0;
    track.onscroll = function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      var ds = dots.children;
      for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('on', k === i);
    };
  }
  var viewer = document.getElementById('plBsViewer');
  var viewerTrack = $('plBsViewerTrack'), viewerCount = $('plBsViewerCount');
  function viewerIndex() {
    return Math.round(viewerTrack.scrollLeft / (viewerTrack.clientWidth || 1));
  }
  function updateViewerCount() {
    var n = viewerTrack.children.length;
    viewerCount.hidden = n < 2;
    viewerCount.textContent = (viewerIndex() + 1) + ' / ' + n;
  }
  function openViewer(list, idx) {
    viewerTrack.innerHTML = '';
    list.forEach(function (u) {
      var s = document.createElement('div');
      s.className = 'pl-bs-viewer__slide';
      s.innerHTML = '<img src="' + u + '" alt="" loading="lazy">';
      viewerTrack.appendChild(s);
    });
    viewer.hidden = false;
    viewerTrack.scrollLeft = viewerTrack.clientWidth * (idx || 0);
    updateViewerCount();
  }
  function closeViewer() {
    /* 閉じたとき、シート側のギャラリーを見ていた画像に合わせる */
    var gt = $('plBsGTrack');
    if (gt && viewerTrack.children.length) gt.scrollLeft = gt.clientWidth * viewerIndex();
    viewer.hidden = true;
    viewerTrack.innerHTML = '';
  }
  viewerTrack.addEventListener('scroll', updateViewerCount);
  /* スワイプ操作では閉じない：指がほぼ動いていないタップだけ閉じる */
  var viewerDown = null;
  viewer.addEventListener('pointerdown', function (e) { viewerDown = { x: e.clientX, y: e.clientY }; });
  viewer.addEventListener('click', function (e) {
    if (viewerDown && (Math.abs(e.clientX - viewerDown.x) > 12 || Math.abs(e.clientY - viewerDown.y) > 12)) return;
    closeViewer();
  });
  /* PC: 矢印キーで隣の画像へ */
  document.addEventListener('keydown', function (e) {
    if (viewer.hidden) return;
    if (e.key === 'ArrowRight') viewerTrack.scrollBy({ left: viewerTrack.clientWidth, behavior: 'smooth' });
    if (e.key === 'ArrowLeft') viewerTrack.scrollBy({ left: -viewerTrack.clientWidth, behavior: 'smooth' });
  });

  function fill(p) {
    current = p;
    buildGallery(p);
    $('plBsCat').textContent = p.cat || '';
    $('plBsTitle').textContent = p.title || '';
    $('plBsPrice').innerHTML = priceHTML(p) + '<span class="pl-bs__ship">' + (p.isSet ? '送料無料' : '商品2個以上購入で送料無料') + '</span><span class="pl-bs__ship">1〜3日で配送</span><span class="pl-bs__ship">国内発送</span>';
    var desc = $('plBsDesc');
    if (p.desc && !p.cvr) { desc.textContent = p.desc; desc.hidden = false; } else { desc.hidden = true; }
    setQty(1);

    var stickyBtn = $('plBsStickyBtn');
    if (stickyBtn) { stickyBtn.innerHTML = ADD_LABEL; stickyBtn.disabled = !p.avail; }
    var stickyBar = $('plBsStickyAdd');
    if (stickyBar) stickyBar.classList.remove('show');

    var buy = $('plBsBuy'), add = $('plBsAdd');
    if (!p.avail) {
      buy.textContent = '売り切れ'; buy.disabled = true; buy.classList.add('disabled');
      add.textContent = '入荷をお待ちください'; add.disabled = true; add.classList.add('disabled'); add.classList.remove('done');
    } else {
      buy.textContent = '今すぐ購入'; buy.disabled = false; buy.classList.remove('disabled');
      add.innerHTML = ADD_LABEL; add.disabled = false; add.classList.remove('disabled', 'done');
    }

    // セット内容（画像＋名前を縦に。タップでその商品の詳細へ）
    var sc = $('plBsSetContents');
    if (sc) {
      if (p.isSet && p.contents && p.contents.length) {
        var sh = '<p class="bscvr-h">セット内容（' + p.contents.length + '点）</p>';
        p.contents.forEach(function (cc) {
          sh += '<button type="button" class="pl-bs__scitem" data-sc-id="' + cc.id + '">' +
            '<span class="scimg">' + (cc.img ? '<img src="' + cc.img + '" alt="">' : '') + '</span>' +
            '<span class="scname">' + (cc.title || '') + '</span>' +
            '<span class="scarw" aria-hidden="true">→</span></button>';
        });
        sc.innerHTML = sh;
        sc.hidden = false;
      } else {
        sc.innerHTML = '';
        sc.hidden = true;
      }
    }

    // CVRコンテンツ（フック〜FAQ〜締めCTA。データに cvr がある商品のみ）
    var hookEl = $('plBsCvrHook'), mainEl = $('plBsCvrMain');
    if (p.cvr) {
      var c = p.cvr;
      hookEl.innerHTML =
        '<p class="bscvr-hook">' + (c.hook || '') + '</p>' +
        (c.hookSub ? '<p class="bscvr-hooksub">' + c.hookSub + '</p>' : '');
      var h = '';
      h += '<div class="bscvr-worry"><p class="bscvr-h">こんなお悩み、ありませんか？</p>' +
        (c.pain ? '<p class="bscvr-pain">' + c.pain + '</p>' : '') +
        (c.turn ? '<p class="bscvr-turn">' + c.turn + '</p>' : '') +
        (c.body ? '<p class="bscvr-body">' + c.body + '</p>' : '') + '</div>';
      if (c.ageBadge) {
        h += '<div class="bscvr-age"><p class="bscvr-h">対象年齢</p><span class="bscvr-agebadge">' + c.ageBadge + '</span>' +
          (c.ageNote ? '<p class="bscvr-agenote">' + c.ageNote + '</p>' : '') + '</div>';
      }
      if (c.steps && c.steps.length) {
        h += '<div class="bscvr-how"><p class="bscvr-h">あそび方はかんたん、3ステップ</p><ol class="bscvr-steps">';
        c.steps.forEach(function (s, i) {
          if (s.comp) {
            /* 画像を使わず、カード素材＋カエル素材をCSSで合成（高精細） */
            var cc = s.comp.cards || [];
            var rots = cc.length === 1 ? [-5] : (cc.length === 2 ? [-7, 7] : [-14, 0, 13]);
            var vis = '';
            cc.forEach(function (u, k) {
              if (k > 0 && s.comp.op) vis += '<span class="op">' + s.comp.op + '</span>';
              /* comp.plain: カード風の角丸・影を付けない素の画像（サイコロ等の切り抜き素材用） */
              /* comp.photo: 実物写真。枠いっぱいに大きく、傾けずに表示する */
              vis += '<img class="cc cc-n' + cc.length + (s.comp.plain ? ' cc--plain' : '') + (s.comp.photo ? ' cc--photo' : '') + '" src="' + u + '" alt="" loading="lazy" style="transform:rotate(' + (s.comp.photo ? 0 : rots[k]) + 'deg)">';
            });
            if (s.comp.frog) vis += '<img class="frog" src="' + s.comp.frog + '" alt="" loading="lazy">';
            /* 上段=番号＋タイトル（横いっぱい）／下段=画像（左）＋説明文（右） */
            h += '<li class="has-img">'
              + '<div class="bscvr-stephead"><span class="bscvr-num">' + (i + 1) + '</span><b>' + (s.t || '') + '</b></div>'
              + '<span class="bscvr-step-vis">' + vis + '</span>'
              + (s.d ? '<p class="bscvr-stepdesc">' + s.d + '</p>' : '')
              + '</li>';
            return;
          }
          if (s.wide) {
            /* 説明入りのデザインパネル画像をそのまま縦に積む */
            h += '<li class="wide-img"><img class="bscvr-step-wide" src="' + s.img + '" alt="STEP' + (i + 1) + ' ' + (s.t || '') + '" loading="lazy"></li>';
            return;
          }
          h += '<li' + (s.img ? ' class="has-img"' : '') + '>'
            + (s.img ? '<img class="bscvr-step-img" src="' + s.img + '" alt="" loading="lazy">' : '')
            + '<div class="bscvr-steprow"><span class="bscvr-num">' + (i + 1) + '</span><div><b>' + (s.t || '') + '</b>' + (s.d ? '<p>' + s.d + '</p>' : '') + '</div></div></li>';
        });
        h += '</ol>';
        /* 例えば…ボックス（ex: [お題, 条件, 答え] の3要素で「A × B ＝ 「C」」を組む） */
        if (c.exComp && c.exComp.length === 3) {
          /* 例えば…をカード画像で表現（exComp:[数字カード, 数字カード, 答えの九九カード]） */
          h += '<div class="bscvr-example bscvr-example--cards"><span class="bscvr-example__tag">例えば…</span>'
            + '<span class="bscvr-excards">'
            + '<img class="bscvr-excard" src="' + c.exComp[0] + '" alt="" loading="lazy">'
            + '<span class="bscvr-example__x">' + (c.exOp || '×') + '</span>'
            + '<img class="bscvr-excard" src="' + c.exComp[1] + '" alt="" loading="lazy">'
            + '<span class="bscvr-example__eq">＝</span>'
            + '<img class="bscvr-excard bscvr-excard--ans" src="' + c.exComp[2] + '" alt="" loading="lazy">'
            + '</span></div>';
        } else if (c.ex && c.ex.length === 3) {
          h += '<div class="bscvr-example"><span class="bscvr-example__tag">例えば…</span>'
            + '<mark>' + c.ex[0] + '</mark> <span class="bscvr-example__x">' + (c.exOp || '×') + '</span> <mark>' + c.ex[1] + '</mark>'
            + ' ＝ 「<b>' + c.ex[2] + '</b>」</div>';
        }
        h += (c.howNote ? '<p class="bscvr-hownote">' + c.howNote + '</p>' : '') + '</div>';
      }
      if (c.skills && c.skills.length) {
        h += '<div class="bscvr-skills"><p class="bscvr-h">遊びながら、身につく力</p><ul>';
        c.skills.forEach(function (s) { h += '<li>' + s + '</li>'; });
        h += '</ul></div>';
      }
      if (c.faq && c.faq.length) {
        h += '<div class="bscvr-faq"><p class="bscvr-h">よくある質問</p>';
        c.faq.forEach(function (f) {
          h += '<details class="bscvr-qa"><summary>' + f.q + '</summary><p>' + f.a + '</p></details>';
        });
        h += '</div>';
      }
      if (c.trust && c.trust.length) {
        h += '<div class="bscvr-trust">';
        c.trust.forEach(function (t) { h += '<span>✓ ' + t + '</span>'; });
        h += '</div>';
      }
      if (c.ctaCopy) {
        h += '<div class="bscvr-cta"><p class="bscvr-ctacopy">' + c.ctaCopy + '</p></div>';
      }
      mainEl.innerHTML = h;
      hookEl.hidden = false;
      mainEl.hidden = false;
    } else {
      hookEl.innerHTML = ''; mainEl.innerHTML = '';
      hookEl.hidden = true; mainEl.hidden = true;
    }

    // 関連おすすめ（セットは「中身と同じ教科の単品」をここで補完）
    var relList = (p.related || []).slice();
    if (p.isSet && p.contents && p.contents.length) {
      var inSet = {}, relTypes = {}, have = {};
      p.contents.forEach(function (cc) {
        inSet[cc.id] = true;
        var full = PRODUCTS[cc.id];
        if (full && full.cat) relTypes[full.cat] = true;
      });
      relList.forEach(function (r) { have[r.id] = true; });
      Object.keys(PRODUCTS).forEach(function (pid) {
        if (relList.length >= 8) return;
        var q = PRODUCTS[pid];
        if (!q || q.isSet || q.id === p.id || inSet[q.id] || have[q.id]) return;
        if (q.cat && relTypes[q.cat]) relList.push(q);
      });
    }
    /* セットは点数が少ない順（2点→4点→…）に前へ。単品はその後ろに元の順で */
    relList = relList
      .map(function (r, i) { return { r: r, i: i }; })
      .sort(function (a, b) {
        var sa = a.r.isSet ? setSize(PRODUCTS[a.r.id] || a.r) : 1000 + a.i;
        var sb = b.r.isSet ? setSize(PRODUCTS[b.r.id] || b.r) : 1000 + b.i;
        return sa - sb || a.i - b.i;
      })
      .map(function (x) { return x.r; });

    var wrap = $('plBsRelWrap'), rel = $('plBsRel');
    rel.innerHTML = '';
    if (relList.length) {
      relList.forEach(function (r) {
        var c = document.createElement('div');
        c.className = 'pl-bs__relcard';
        var relSet = !!r.isSet;
        c.innerHTML =
          '<div class="relimg">' + (relSet ? '<span class="reloff">10%OFF</span>' : '') + (r.img ? '<img src="' + r.img + '" alt="">' : '') + '</div>' +
          '<div class="relname">' + (r.title || '') + '</div>' +
          '<div class="relprice">' + (r.onSale ? '<span class="relnow">' + (r.priceF || '') + '</span><span class="relwas">' + (r.cmpF || '') + '</span>' : (r.priceF || '')) + '</div>' +
          (relSet ? '<div class="relship">送料無料</div>' : '');
        c.addEventListener('click', function () { clearBackStack(); fill(PRODUCTS[r.id] || r); sheet.scrollTop = 0; });
        rel.appendChild(c);
      });
      wrap.hidden = false;
    } else {
      wrap.hidden = true;
    }
  }

  // ---- 開閉 ----
  function openSheet(p, trigger) {
    lastFocus = trigger || document.activeElement;
    // ヘッダーの実高さを測り、シート上端が常にヘッダーの下（カートが見える位置）で止まるように
    var hd = document.querySelector('header.header');
    var topGap = hd ? Math.ceil(hd.getBoundingClientRect().bottom) + 8 : 90;
    sheet.style.maxHeight = 'calc(100vh - ' + topGap + 'px)';
    fill(p);
    step1.hidden = false; step2.hidden = true;
    var ss = document.getElementById('plBsStepSets'); if (ss) ss.hidden = true;
    sheet.classList.remove('pl-bs--tall');
    clearBackStack();
    backdrop.classList.add('open');
    sheet.classList.add('open');
    document.body.classList.add('pl-bs-open'); // 浮遊バッジ等を隠す
    sheet.setAttribute('aria-hidden', 'false');
    sheet.scrollTop = 0;
    lockScroll();
    var f = $('plBsClose'); if (f) f.focus();
  }
  function closeSheet() {
    backdrop.classList.remove('open');
    sheet.classList.remove('open');
    sheet.classList.remove('pl-bs--tall');
    clearBackStack();
    document.body.classList.remove('pl-bs-open');
    sheet.style.transform = '';
    sheet.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  backdrop.addEventListener('click', closeSheet);

  // カートモーダル等から商品IDでシートを開けるように公開
  window.plBsGetProduct = function (pid) { return PRODUCTS[pid] || null; };
  /* URLの ?bs=商品ID で商品詳細シートを自動で開く（紹介ページ等からの遷移用） */
  setTimeout(function () {
    try {
      var bsAuto = new URLSearchParams(location.search).get('bs');
      if (bsAuto && PRODUCTS[bsAuto]) window.plBsOpenById(bsAuto);
    } catch (e) { /* URLSearchParams非対応は無視 */ }
  }, 250);

  window.plBsOpenById = function (pid, opts) {
    var p = PRODUCTS[pid];
    if (p) {
      openSheet(p);
      if (opts && opts.fromCart) {
        backStack.push({ type: 'cart', label: '← カートにもどる' });
        syncBackBtn();
      }
    }
    return !!p;
  };
  $('plBsClose').addEventListener('click', closeSheet);

  // ---- カードのタップでシートを開く（JS無効時は従来どおり商品ページへ＝フォールバック）----
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-pl-bs-id]');
    if (!card) return;
    var p = PRODUCTS[card.getAttribute('data-pl-bs-id')];
    if (!p) return;
    e.preventDefault();
    openSheet(p, card);
  });

  // ---- 数量 ----
  $('plBsQm').addEventListener('click', function () { setQty(qty() - 1); });
  $('plBsQp').addEventListener('click', function () { setQty(qty() + 1); });

  // ---- 購入前の確認ダイアログ ----
  var confirmEl = document.getElementById('plBsConfirm');
  function showConfirm(msg, yesLabel, noLabel, onYes, onNo) {
    if (!confirmEl) { onYes(); return; }
    document.getElementById('plBsConfirmMsg').innerHTML = msg;
    var yes = document.getElementById('plBsConfirmYes');
    var no = document.getElementById('plBsConfirmNo');
    yes.textContent = yesLabel;
    no.textContent = noLabel;
    confirmEl.hidden = false;
    function cleanup() {
      confirmEl.hidden = true;
      yes.onclick = null;
      no.onclick = null;
    }
    yes.onclick = function () { cleanup(); onYes(); };
    no.onclick = function () { cleanup(); if (onNo) onNo(); };
  }

  // 購入アクション前のチェック：
  // ② セット内容経由で単品を買おうとしたら「セットで入れますか？」
  // ① セット購入時にカート内へ中身の単品が重複していたら「単品を削除しますか？」
  function purchaseGate(proceed, action) {
    if (!current) { proceed(); return; }

    var topE = backStack.length ? backStack[backStack.length - 1] : null;
    if (!current.isSet && topE && topE.type === 'product' && topE.product && topE.product.isSet) {
      var os = topE.product;
      showConfirm(
        'この商品は「' + (os.title || '') + '」に含まれています。セット商品（<b class="cf-em">10%OFF</b>・<b class="cf-em">送料無料</b>）としてカートに入れますか？',
        'セットで入れる', '単品のまま進む',
        function () {
          clearBackStack();
          fill(os);
          sheet.scrollTop = 0;
          proceed();
        },
        proceed
      );
      return;
    }

    // ③ 単品の「カートに追加」時：カートの単品＋この商品でセットが完成するなら提案
    if (!current.isSet && action === 'add') {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var lines = {};
          (c.items || []).forEach(function (it) { if (!it.gift_card) lines[it.product_id] = it; });
          var combo = {};
          Object.keys(lines).forEach(function (k) { combo[k] = true; });
          combo[current.id] = true;

          var best = null;
          Object.keys(PRODUCTS).forEach(function (k) {
            var s = PRODUCTS[k];
            if (!s.isSet || !s.contents || s.contents.length < 2) return;
            var hasCurrent = s.contents.some(function (cc) { return cc.id === current.id; });
            if (!hasCurrent) return;
            var complete = s.contents.every(function (cc) { return combo[cc.id]; });
            if (complete && (!best || s.contents.length > best.contents.length)) best = s;
          });
          if (!best) { proceed(); return; }

          var names = best.contents.map(function (cc) { return '<b class="cf-em">「' + cc.title + '」</b>'; }).join('と');
          showConfirm(
            names + 'の組み合わせは、セット「' + (best.title || '') + '」なら<b class="cf-em">10%OFF</b>・<b class="cf-em">送料無料</b>です。セットに切り替えますか？',
            'セットに切り替える', '単品のまま進む',
            function () {
              // カート内の該当単品を削除 → セットを追加 → 画面もセットへ
              var seq = Promise.resolve();
              best.contents.forEach(function (cc) {
                var line = lines[cc.id];
                if (!line) return;
                seq = seq.then(function () {
                  return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: line.key, quantity: 0 })
                  });
                });
              });
              seq.then(function () { return addToCart(best.vid, 1); })
                .then(function () {
                  refreshCartCount();
                  toast('セットに切り替えました ✓');
                  clearBackStack();
                  fill(best);
                  sheet.scrollTop = 0;
                })["catch"](function () {
                  toast('切り替えに失敗しました。もう一度お試しください');
                  refreshCartCount();
                });
            },
            proceed
          );
        })["catch"](function () { proceed(); });
      return;
    }

    if (current.isSet && current.contents && current.contents.length) {
      gateSetDup(current, proceed);
      return;
    }

    proceed();
  }

  /* セット追加前の単品重複チェック（レコメンドパネルからの追加でも使う） */
  function gateSetDup(prod, proceed) {
    if (!prod || !prod.isSet || !prod.contents || !prod.contents.length) { proceed(); return; }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var ids = {};
        prod.contents.forEach(function (x) { ids[x.id] = true; });
        var dups = (c.items || []).filter(function (it) { return ids[it.product_id]; });
        if (!dups.length) { proceed(); return; }
        var names = dups.map(function (it) { return '<b class="cf-em">「' + it.product_title + '」</b>'; }).join('');
        showConfirm(
          'カートに入っている単品' + names + 'は、このセットに含まれています。カートの単品を削除しますか？',
          '単品を削除して進む', 'そのまま進む',
          function () {
            var seq = Promise.resolve();
            dups.forEach(function (it) {
              seq = seq.then(function () {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ id: it.key, quantity: 0 })
                });
              });
            });
            seq.then(function () { refreshCartCount(); proceed(); })["catch"](function () { proceed(); });
          },
          proceed
        );
      })["catch"](function () { proceed(); });
  }

  // ---- カートに追加（本物のカート・閉じない）----
  function addToCart(vid, q) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: q }] })
    });
  }
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count').forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = false;
          el.removeAttribute('hidden');
        });
      })["catch"](function () {});
  }
  // ==== カート追加演出: 商品画像がカートへ飛ぶ ====
  function flyToCart(originEl, imgSrc) {
    var srcImg = document.querySelector('#plBsGTrack .pl-bs__gslide img');
    var pic = imgSrc || (srcImg && srcImg.src);
    var origin = originEl || srcImg;
    if (!origin || !pic) return;
    /* 起点は押した「カートに追加」ボタン。飛ぶ絵は商品画像 */
    var s = origin.getBoundingClientRect();
    if (!s.width) return;
    /* 行き先は右上ヘッダーのカートアイコン（SP: header-cart-btn / PC: ヘッダー内カートリンク） */
    var badge = document.querySelector('.header-cart-btn');
    if (!badge || !badge.offsetParent) {
      badge = document.querySelector('header a[href*="cart"] .icon-container') || document.querySelector('header a[href*="cart"]');
    }
    var b = (badge && badge.offsetParent) ? badge.getBoundingClientRect() : null;
    var tx = (b && b.width) ? b.left + b.width / 2 : window.innerWidth - 64;
    var ty = (b && b.width) ? b.top + b.height / 2 : 30;
    var fly = document.createElement('img');
    fly.className = 'pl-bs-fly';
    fly.src = pic;
    fly.style.left = (s.left + s.width / 2 - 37) + 'px';
    fly.style.top = (s.top + s.height / 2 - 37) + 'px';
    document.body.appendChild(fly);
    var dx = tx - 37 - parseFloat(fly.style.left);
    var dy = ty - 37 - parseFloat(fly.style.top);
    /* どのボタンから飛んでも同じ見え方になるよう、山なりの弧と飛行時間を飛距離に比例させる
       （基準: シート下部のカートに追加ボタン → ヘッダーカート ≒ 650px を1.0とする） */
    var k = Math.max(0.35, Math.min(1, Math.abs(dy) / 650));
    var popMs = 240, flightMs = Math.round(1060 * k), totalMs = popMs + flightMs;
    var pEnd = popMs / totalMs;
    function ofs(f) { return Math.round((pEnd + (1 - pEnd) * f) * 1000) / 1000; }
    if (fly.animate) {
      fly.animate([
        /* まずボタンの上でポンッと現れて一瞬とどまる（見逃し防止） */
        { transform: 'translate(0,0) scale(.6) rotate(0deg)', opacity: 0.9, easing: 'cubic-bezier(.34,1.56,.64,1)' },
        { transform: 'translate(0,-16px) scale(1.12) rotate(0deg)', opacity: 1, offset: pEnd, easing: 'ease-in-out' },
        /* 上昇は中間キーフレーム無しの一直線（途中で止まったり角度が変わったりしない）
           → カートの高さで、まだ大きく見えるうちに右へ「しゅっ」と入る */
        { transform: 'translate(' + (dx - 84) + 'px,' + (dy - 4) + 'px) scale(.6) rotate(-14deg)', opacity: 1, offset: ofs(0.82), easing: 'cubic-bezier(.4,0,.8,.6)' },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.28) rotate(-20deg)', opacity: 0.45 }
      ], { duration: totalMs }).onfinish = function () {
        fly.remove();
        if (badge && badge.animate) {
          badge.animate([
            { transform: 'scale(1)' },
            { transform: 'scale(1.3) rotate(-6deg)', offset: 0.35 },
            { transform: 'scale(.94)', offset: 0.7 },
            { transform: 'scale(1)' }
          ], { duration: 420, easing: 'ease-out' });
        }
      };
    } else {
      setTimeout(function () { fly.remove(); }, totalMs);
    }
  }

  // ==== カート追加後のレコメンドパネル ====
  var recWrap = $('plBsRecWrap');
  /* transform付きの祖先(.product-grid-container)の中だとfixedが効かずシートの下に潜るため、body直下へ移す */
  if (recWrap && recWrap.parentElement !== document.body) document.body.appendChild(recWrap);
  function recRow(r, hot) {
    var full = PRODUCTS[r.id] || r;
    var price;
    if (full.isSet && full.onSale && full.cmpF) {
      price = '<s>' + full.cmpF + '</s> <b>' + full.priceF + '</b><span class="pl-bs-rec__off">セール中</span>';
    } else {
      price = full.priceF || '';
    }
    return '<div class="pl-bs-rec__item' + (hot ? ' pl-bs-rec__item--hot' : '') + '" data-rec-pid="' + (full.id || '') + '" role="button" tabindex="0">'
      + '<span class="pl-bs-rec__im">' + (full.img ? '<img src="' + full.img + '" alt="">' : '') + '</span>'
      + '<span class="pl-bs-rec__info"><span class="pl-bs-rec__nm">' + (full.title || '') + '</span>'
      + '<span class="pl-bs-rec__pr" style="display:block">' + price + '</span></span>'
      + '<button type="button" class="pl-bs-rec__addbtn" data-rec-vid="' + (full.vid || '') + '">＋ 追加</button>'
      + '</div>';
  }
  function showRecPanel(p, q) {
    if (!recWrap || !p) return;
    $('plBsRecAdded').innerHTML = (p.title || '') + ' をカートに追加しました<small>' + (p.priceF || '') + ' × ' + q + '点</small>';
    $('plBsRecTitle').innerHTML = (p.title || '') + ' と<span>一緒に購入されている</span>商品';
    var rows = '';
    var rel = (p.related || []).filter(function (r) { return r.avail !== false; });
    if (!p.isSet) {
      /* 単品: 同教科の単品を2つ＋その商品入りの最小セットを強調枠で */
      var singles = rel.filter(function (r) { return !r.isSet; });
      if (singles.length < 2) {
        Object.keys(PRODUCTS).some(function (pid) {
          var c = PRODUCTS[pid];
          if (!c.isSet && c.id !== p.id && c.cat && c.cat === p.cat && c.avail !== false && singles.indexOf(c) < 0
              && !singles.some(function (s2) { return s2.id === c.id; })) singles.push(c);
          return singles.length >= 2;
        });
      }
      singles.slice(0, 2).forEach(function (r) { rows += recRow(r, false); });
      var sets = rel.filter(function (r) { return r.isSet; }).sort(function (a, b) {
        return setSize(PRODUCTS[a.id] || a) - setSize(PRODUCTS[b.id] || b);
      });
      if (sets[0]) rows += recRow(sets[0], true);
    } else {
      rel.slice(0, 3).forEach(function (r) { rows += recRow(r, false); });
    }
    $('plBsRecItems').innerHTML = rows;
    /* 上部ヘッダーに被らないよう、ヘッダー下端からパネルを出す */
    var hd = document.querySelector('header.header') || document.querySelector('header');
    var hb = hd ? hd.getBoundingClientRect().bottom : 0;
    recWrap.querySelector('.pl-bs-rec__panel').style.top = Math.max(0, Math.round(hb) + 8) + 'px';
    recWrap.hidden = false;
    void recWrap.offsetWidth;   /* 表示してからtransitionを効かせる */
    recWrap.classList.add('show');
  }
  function closeRecPanel() {
    recWrap.classList.remove('show');
    setTimeout(function () { recWrap.hidden = true; }, 400);
  }
  $('plBsRecShade').addEventListener('click', closeRecPanel);
  $('plBsRecClose').addEventListener('click', closeRecPanel);
  $('plBsRecCart').addEventListener('click', function () {
    closeRecPanel();
    closeSheet();
    var openBtn = document.querySelector('[data-cart-open]');
    if (openBtn) setTimeout(function () { openBtn.click(); }, 200);
  });
  recWrap.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rec-vid]');
    if (!btn) {
      /* 追加ボタン以外の行タップ → その商品の詳細シートへ（商品一覧から開いた時と同じ状態） */
      var row = e.target.closest('[data-rec-pid]');
      if (row && row.getAttribute('data-rec-pid') && PRODUCTS[row.getAttribute('data-rec-pid')]) {
        closeRecPanel();
        window.plBsOpenById(row.getAttribute('data-rec-pid'));
      }
      return;
    }
    if (btn.disabled || !btn.getAttribute('data-rec-vid')) return;
    var row = btn.closest('[data-rec-pid]');
    var rowImg = row ? row.querySelector('.pl-bs-rec__im img') : null;
    var full = row ? PRODUCTS[row.getAttribute('data-rec-pid')] : null;
    var doAdd = function () {
      /* 起点は行の商品画像。＋追加ボタンはカート直下で横移動が無く「右にしゅっ」と入る動きが出ないため */
      flyToCart(rowImg || btn, rowImg ? rowImg.src : null);
      btn.disabled = true;
      addToCart(btn.getAttribute('data-rec-vid'), 1).then(function (r) {
        if (!r.ok) throw new Error();
        refreshCartCount();
        btn.classList.add('in');
        btn.textContent = '✓ 追加済み';
      })["catch"](function () {
        btn.disabled = false;
        toast('追加できませんでした。もう一度お試しください');
      });
    };
    /* セットを追加する時：カート内にそのセットの単品があれば削除を提案してから */
    if (full && full.isSet) { gateSetDup(full, doAdd); } else { doAdd(); }
  });

  $('plBsAdd').addEventListener('click', function () {
    var btn = this;
    if (btn.disabled || !current) return;
    flyToCart(btn);   /* 押した瞬間に演出開始（ガードの通信も待たない） */
    purchaseGate(function () {
    var q = qty();
    btn.disabled = true;
    addToCart(current.vid, q).then(function (r) {
      if (!r.ok) throw new Error();
      refreshCartCount();
      showRecPanel(current, q);
      btn.textContent = '追加しました ✓'; btn.classList.add('done');
      setTimeout(function () {
        btn.innerHTML = ADD_LABEL; btn.classList.remove('done'); btn.disabled = false;
      }, 1400);
    })["catch"](function () {
      toast('追加できませんでした。もう一度お試しください');
      btn.disabled = false;
    });
    }, 'add');
  });

  // ---- 左上の戻るボタン（履歴スタック：一覧→セット→単品…と何段でも戻れる） ----
  var backStack = [];
  var backSetBtn = $('plBsBackSet');
  var stepSets = document.getElementById('plBsStepSets');
  function syncBackBtn() {
    if (!backSetBtn) return;
    if (backStack.length) {
      backSetBtn.textContent = backStack[backStack.length - 1].label;
      backSetBtn.hidden = false;
    } else {
      backSetBtn.hidden = true;
    }
  }
  function clearBackStack() {
    backStack = [];
    syncBackBtn();
  }
  function hideBackSet() { clearBackStack(); } // 互換用

  // セット一覧パネルを組み立てて表示
  function buildSetList(p) {
    var sets = (p.related || []).filter(function (r) { return r.isSet; });
    // セット点数が少ない順（2点→4点→9点）に並べる
    sets.sort(function (a, b) {
      return setSize(PRODUCTS[a.id] || a) - setSize(PRODUCTS[b.id] || b);
    });
    var listEl = $('plBsSetList');
    $('plBsSetsTitle').textContent = (p.title || '') + 'が入ったセット';
    var h = '';
    sets.forEach(function (s) {
      h += '<button type="button" class="pl-bs__setrow" data-id="' + s.id + '">' +
        '<span class="srimg">' + (s.img ? '<img src="' + s.img + '" alt="">' : '') + '</span>' +
        '<span class="srinfo">' +
          '<span class="srname">' + (s.title || '') + '</span>' +
          '<span class="srprice">' +
            (s.onSale ? '<span class="srnow">' + (s.priceF || '') + '</span><span class="srwas">' + (s.cmpF || '') + '</span>' : (s.priceF || '')) +
          '</span>' +
          '<span class="srtags"><span class="sroff">10%OFF</span><span class="srship">送料無料</span></span>' +
        '</span>' +
        '<span class="srarw" aria-hidden="true">→</span></button>';
    });
    listEl.innerHTML = h;
    step1.hidden = true; step2.hidden = true;
    if (stepSets) stepSets.hidden = false;
    sheet.classList.add('pl-bs--tall'); // 一覧は常に高い位置まで開く
    sheet.scrollTop = 0;
  }

  // カート等から：商品IDでセット一覧を開く（セットが無い商品はそのまま詳細）
  window.plBsOpenSetList = function (pid) {
    var p = PRODUCTS[pid];
    if (!p) return false;
    var sets = (p.related || []).filter(function (r) { return r.isSet; });
    openSheet(p);
    if (sets.length) {
      hideBackSet();
      buildSetList(p);
    }
    return true;
  };

  // 一覧の行タップ → そのセットの詳細（左上に「一覧にもどる」）
  sheet.addEventListener('click', function (e) {
    var row = e.target.closest('.pl-bs__setrow');
    if (!row) return;
    var listSource = current; // 一覧の元になった商品
    var sp = PRODUCTS[row.getAttribute('data-id')];
    if (!sp) return;
    fill(sp);
    if (stepSets) stepSets.hidden = true;
    step1.hidden = false;
    sheet.classList.remove('pl-bs--tall');
    sheet.scrollTop = 0;
    backStack.push({ type: 'list', product: listSource, label: '← 一覧にもどる' });
    syncBackBtn();
  });

  // 一覧パネルの「もどる」→ シートを閉じてカートを再表示
  var setsBackBtn = document.getElementById('plBsSetsBack');
  if (setsBackBtn) {
    setsBackBtn.addEventListener('click', function () {
      closeSheet();
      var opener = document.querySelector('[data-cart-open]');
      if (opener) opener.click();
    });
  }

  // セット内容タップ → その商品の詳細に切替（「セットにもどる」）
  sheet.addEventListener('click', function (e) {
    var btn = e.target.closest('.pl-bs__scitem');
    if (!btn) return;
    var fromSet = current;
    var pp = PRODUCTS[btn.getAttribute('data-sc-id')];
    if (pp) {
      fill(pp);
      sheet.scrollTop = 0;
      if (fromSet && fromSet.isSet) {
        backStack.push({ type: 'product', product: fromSet, label: '← セットにもどる' });
        syncBackBtn();
      }
    }
  });

  if (backSetBtn) {
    backSetBtn.addEventListener('click', function () {
      var entry = backStack.pop();
      syncBackBtn();
      if (!entry) return;
      if (entry.type === 'cart') {
        closeSheet();
        var opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click();
      } else if (entry.type === 'list') {
        if (entry.product) { current = entry.product; buildSetList(entry.product); }
      } else {
        if (entry.product) { fill(entry.product); sheet.scrollTop = 0; }
      }
    });
  }

  // ---- 追尾カートバー：最初のボタン行が上に見切れたら表示 ----
  (function () {
    var bar = $('plBsStickyAdd');
    var btnsRow = sheet.querySelector('.pl-bs__btns');
    if (!bar || !btnsRow || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var scrolledPast = !en.isIntersecting && en.boundingClientRect.top < (en.rootBounds ? en.rootBounds.top : 0);
      var ok = current && current.avail;
      bar.classList.toggle('show', !!(scrolledPast && ok));
    }, { root: sheet, threshold: 0 }).observe(btnsRow);
  })();

  // ---- CVR最下部の「カートに追加」（委譲） ----
  sheet.addEventListener('click', function (e) {
    var btn = e.target.closest('.bscvr-add');
    if (!btn || btn.disabled || !current) return;
    flyToCart(btn);   /* 押した瞬間に演出開始（ガードの通信も待たない） */
    purchaseGate(function () {
    btn.disabled = true;
    var q = qty();
    addToCart(current.vid, q).then(function (r) {
      if (!r.ok) throw new Error();
      refreshCartCount();
      showRecPanel(current, q);
      btn.textContent = '追加しました ✓';
      setTimeout(function () { btn.innerHTML = ADD_LABEL; btn.disabled = false; }, 1400);
    })["catch"](function () {
      toast('追加できませんでした。もう一度お試しください');
      btn.disabled = false;
    });
    }, 'add');
  });

  // ---- 今すぐ購入 → ステップ2 ----
  function slide(stepEl, cls) { stepEl.classList.remove(cls); void stepEl.offsetWidth; stepEl.classList.add(cls); }
  function goStep2() {
    if (!current) return;
    var q = qty();
    var yen = Math.round((current.unit || 0) * q / 100); // Shopifyのpriceは×100（例:1960円=196000）なので100で割る
    $('plBsOrder').innerHTML =
      '<div class="os-img">' + (current.img ? '<img src="' + current.img + '" alt="">' : '') + '</div>' +
      '<div class="os-mid"><div class="os-name">' + (current.title || '') + '</div><div class="os-q">数量 ' + q + '点</div></div>' +
      '<div class="os-total">¥' + yen.toLocaleString() + '</div>';
    // 送料無料まであといくら（¥2,500未満のときだけ表示）
    var shipEl = $('plBsShipNote');
    if (shipEl) {
      var totalCents = (current.unit || 0) * q;
      var FREE = 250000;
      if (totalCents > 0 && totalCents < FREE) {
        var remain = Math.round((FREE - totalCents) / 100);
        var pct = Math.min(100, Math.round((totalCents / FREE) * 100));
        shipEl.innerHTML =
          '<p class="shipnote-t">あと <b>¥' + remain.toLocaleString() + '</b> で送料無料</p>' +
          '<span class="shipnote-bar"><i style="width:' + pct + '%"></i></span>';
        shipEl.hidden = false;
      } else {
        shipEl.hidden = true;
      }
    }
    step1.hidden = true; step2.hidden = false;
    slide(step2, 'pl-slide-r');
    sheet.scrollTop = 0;
    var pb = $('plBsPlace'); if (pb) pb.focus();
  }
  function backStep1() {
    step2.hidden = true; step1.hidden = false;
    slide(step1, 'pl-slide-l');
    sheet.scrollTop = 0;
  }
  $('plBsBuy').addEventListener('click', function () { if (!this.disabled) purchaseGate(goStep2, 'buy'); });
  $('plBsBack').addEventListener('click', backStep1);

  // ---- 「購入手続きへ進む」→ カートパーマリンクで“この商品のみ”を直接チェックアウトへ ----
  //（既存カートの中身には影響しない。住所・支払いはShopify決済画面で入力＝Apple Pay等なら自動入力）
  $('plBsPlace').addEventListener('click', function () {
    if (!current) return;
    var btn = this; btn.disabled = true; btn.textContent = '決済画面へ移動中…';
    window.location.href = '/cart/' + current.vid + ':' + qty();
  });

  // ---- 上バーをスワイプで閉じる ----
  var grip = $('plBsGrip'), sy = null, dy = 0;
  grip.addEventListener('pointerdown', function (e) { sy = e.clientY; sheet.style.transition = 'none'; try { grip.setPointerCapture(e.pointerId); } catch (x) {} });
  grip.addEventListener('pointermove', function (e) { if (sy == null) return; dy = Math.max(0, e.clientY - sy); sheet.style.transform = 'translateY(' + dy + 'px)'; });
  grip.addEventListener('pointerup', function () { if (sy == null) return; sheet.style.transition = ''; if (dy > 90) { closeSheet(); } else { sheet.style.transform = ''; } sy = null; dy = 0; });

  // ---- キーボード：ESCで閉じる / Tabでシート内フォーカストラップ ----
  document.addEventListener('keydown', function (e) {
    if (sheet.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') { if (recWrap && !recWrap.hidden) { closeRecPanel(); } else if (!viewer.hidden) { closeViewer(); } else { closeSheet(); } return; }
    if (e.key !== 'Tab') return;
    var f = sheet.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
